import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, FormHelperText, MenuItem, Select } from '@mui/material';
import { DatasetCreationEnum } from '~/api/types';
import { useGetDatasetEnumsQuery } from '~/api/v2/hooks';
import { InfoFormLabel, SelectPlaceholder } from '~/components';
import { useHasLockedStatus } from '~/hooks/dataset';

const DeidentifiedStatusField = () => {
  const { data, isFetching } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.DEIDENTIFIED_STATUS });
  const { control } = useFormContext();
  const { hasLockedStatus } = useHasLockedStatus();

  return (
    <FormControlLabel
      label={
        <InfoFormLabel
          label="DE-IDENTIFIED STATUS"
          tooltipText="Please select the level at which this information has been de-identified. This can be edited if additional de-identification takes place."
        />
      }
      required
      control={
        <Controller
          name="de_identified"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState }) => (
            <>
              <FormHelperText error={!!fieldState.error}>{fieldState.error?.message as string}</FormHelperText>
              <Select
                {...field}
                value={field.value ?? ''}
                disabled={isFetching || hasLockedStatus}
                error={!!fieldState.error}
                renderValue={() => {
                  if (!field.value) return <SelectPlaceholder>Select the de-identified status</SelectPlaceholder>;

                  return field.value;
                }}
              >
                {data?.map(({ value }) => (
                  <MenuItem key={value} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        />
      }
    />
  );
};

export default DeidentifiedStatusField;
